import { handleActions } from 'redux-actions';
import type {
  BoostInitializationStoreSlice,
  NetworkRequestStatus,
} from '../types';
import {
  initialize,
  initializeSuccess,
  initializeError,
  deinitialize,
} from '../actions';
import { reduxKey } from '../constants';

const initialState: BoostInitializationStoreSlice = {
  requestStatus: 'idle' as NetworkRequestStatus,
  requestError: undefined,
  isInitialized: false,
  deviationId: undefined,
  tags: [],
  recommendedTags: [],
};

const actionHandlers = handleActions<BoostInitializationStoreSlice, any>(
  {
    [`${initialize}`]: (state, action: ReturnType<typeof initialize>) => ({
      ...state,
      requestStatus: 'fetching' as NetworkRequestStatus,
      requestError: undefined,
      deviationId: action.payload.deviationId,
    }),
    [`${initializeSuccess}`]: (
      state,
      action: ReturnType<typeof initializeSuccess>
    ) => ({
      ...state,
      requestStatus: 'success' as NetworkRequestStatus,
      requestError: undefined,
      isInitialized: true,
      deviationId: action.payload.deviationId,
      tags: action.payload.tags,
      recommendedTags: action.payload.recommendedTags,
    }),
    [`${initializeError}`]: (
      state,
      action: ReturnType<typeof initializeError>
    ) => ({
      ...state,
      requestStatus: 'error' as NetworkRequestStatus,
      requestError: action.payload.errorMessage,
    }),

    [`${deinitialize}`]: (state, action: ReturnType<typeof deinitialize>) => ({
      ...state,
      requestStatus: 'idle' as NetworkRequestStatus,
      requestError: undefined,
      isInitialized: false,
      deviationId: undefined,
      tags: [],
      recommendedTags: [],
    }),
  },
  {
    ...initialState,
  }
);

const reducers = {
  [reduxKey as string]: actionHandlers,
};

export default reducers;
